import '../components/vendor/fancybox/jquery.fancybox';




// WEBPACK FOOTER //
// ./scripts/autoload/_fancybox.js